import { render, staticRenderFns } from "./ChipMenu.vue?vue&type=template&id=52639e62"
import script from "./ChipMenu.vue?vue&type=script&lang=js"
export * from "./ChipMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports